import React, { useContext } from "react";
import { DesktopDatePicker, DesktopDateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { itIT } from "@mui/x-date-pickers/locales";
import dayjs, { isDayjs } from "dayjs";
import { ModuleContext } from "../utils/Constants";
import { useSelector } from "react-redux";
import { isComponentDisabled, isComponentVisible } from "../utils/SaitUtils";

export default function SaitDateField(props) {
	const componentModule = useContext(ModuleContext);
	const objModArray = useSelector((state) => state["auth"]["objMod"]);
	const objMod = objModArray.find((objModObject) => objModObject.moduleName === componentModule && objModObject.idObject === props.objmod);

	const textFieldSlotProps = {
		error: props.error,
		style: props.style,
		sx: {
			...props.sx,
		},
		InputProps: {
			sx: {
				"&.Mui-disabled": {
					backgroundColor: "#f0f0f0 !important",
					borderRadius: 1,
					color: "#212121 !important",
					WebkitTextFillColor: "#212121 !important", // Chrome/Edge fix
				},
			},
		},
		InputLabelProps: {
			sx: {
				"&.Mui-disabled": {
					color: "#424242 !important",
				},
			},
		},
		size: props.size || "small",
		required: props.required,
		onKeyDown: (event) => props.onKeyDown?.(event),
	};

	return isComponentVisible(objMod, props.hidden) ? (
		<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it" localeText={itIT.components.MuiLocalizationProvider.defaultProps.localeText}>
			{props.time ? (
				<DesktopDateTimePicker
					label={props.label}
					format={props.format || "DD/MM/YYYY HH:mm"}
					disabled={isComponentDisabled(objMod, props.disabled)}
					value={props.value ? (isDayjs(props.value) ? props.value : dayjs(props.value)) : null}
					onChange={(newDate) => props.onChange(newDate)}
					views={props.views || undefined}
					openTo={props.openTo || "day"}
					disablePast={props.disablePast || false}
					slotProps={{ textField: textFieldSlotProps }}
				/>
			) : (
				<DesktopDatePicker
					views={props.views || undefined}
					label={props.label}
					format={props.format || "DD/MM/YYYY"}
					disabled={isComponentDisabled(objMod, props.disabled)}
					value={props.value ? (isDayjs(props.value) ? props.value : dayjs(props.value)) : null}
					onChange={(newDate) => props.onChange(newDate)}
					openTo={props.openTo || "day"}
					disablePast={props.disablePast || false}
					slotProps={{ textField: textFieldSlotProps }}
				/>
			)}
		</LocalizationProvider>
	) : null;
}
